import { makeStyles } from '@material-ui/styles'

const styles = makeStyles((theme) => ({
  noWrap: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  wrap: {
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
  },
}))

export default styles
